import * as React from "react";
import Loader from "react-loader";
import { Redirect } from "react-router-dom";
import Sidenav, {
  Toggle,
  Nav,
  NavItem,
  NavIcon,
  NavText
} from "@trendmicro/react-sidenav";
import { CSSTransition } from "react-transition-group";
import ClickOutside from "react-click-outside";

// services
import {
  currentBaseUrl,
  currentUser,
  currentUserAge,
  currentUserSchool,
  getGeneralSmartTableData,
  isBasicPreassessmentDone,
  isUserLoggedIn,
  isUserUpgraded
} from "../../../common/services";

import NavBar from "../../../components/CustomNav/CustomNav.Component";
import ResponsesTile from "../../../common/responsesTile.Component";
import TraitTile from "../../../common/traitTile.Component";
import PerceptionsTile from "../../../common/perceptionsTile.Component";

import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import "./StudentDataCenter.css";
import icon1 from "../../../assets/images/sideicon1.png";
import icon2 from "../../../assets/images/sideicon2.png";
import icon3 from "../../../assets/images/perceptionicon.png";

// dummy data
import { response } from "../../../assets/data/sampleResults";
import PerceptionScatterGraph from "../../../common/DataViz/studentPerceptionGraph.Component";

import PlexLoader from "../../../common/CustomLoader/customLoader.Component";

interface IProps {
  services?: any;
}

class StudentDataCenter extends React.Component<IProps> {
  public state = {
    assessmentinfo: {} as any,
    baseurl: currentBaseUrl(),
    breakdown: {} as any,
    currentassessmentid: 0,
    currentUser: currentUser(),
    destination: "",
    infofields: {
      id: "id"
    },
    navigate: false,
    resultfields: {
      info: "assessment_info",
      results: "results"
    },
    toLogin: false,
    toProfile: false,
    sideNavCategory: "summary",
    dummyData: response,
    sideNavOpen: false
  };
  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.getAssessmentsViz = this.getAssessmentsViz.bind(this);
    this.getSummaryViz = this.getSummaryViz.bind(this);
    this.chooseCategory = this.chooseCategory.bind(this);
    this.getPerceptionsPlot = this.getPerceptionsPlot.bind(this);
    this.handleAssessmentInfoLoaded = this.handleAssessmentInfoLoaded.bind(
      this
    );
    this.handleAssessmentResultsLoaded = this.handleAssessmentResultsLoaded.bind(
      this
    );
    this.handleAssessmentBreakdownLoaded = this.handleAssessmentBreakdownLoaded.bind(
      this
    );
    this.openWidget = this.openWidget.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);
    this.toggleSideNav = this.toggleSideNav.bind(this);
  }

  public componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
    } else {
      window.scrollTo(0, 0);

      this.setState({ username: currentUser() });

      // load data latest assessment
      getGeneralSmartTableData(
        "admin/assessments/get_latest_user_assessment_details/",
        text => this.handleAssessmentInfoLoaded(text)
      );

      // load breakdown
      getGeneralSmartTableData("datacenter/assessments_breakdown", text =>
        this.handleAssessmentBreakdownLoaded(text)
      );
    }
  }

  public handleAssessmentBreakdownLoaded(res) {
    if (res.code === 200) {
      console.log(
        "Response Breakdown: " + JSON.stringify(res.response, null, 4)
      );
      this.setState({ breakdown: res.response.breakdown });
    } else if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public handleAssessmentChosen(res) {
    console.log(res);
  }

  public handleAssessmentInfoLoaded(res) {
    if (res.code === 200) {
      console.log("SDC Assessments" + JSON.stringify(res, null, 4));
      this.setState({
        currentassessmentid: res.response[this.state.infofields.id]
      });
      console.info("ASSID: " + this.state.infofields.id)
      getGeneralSmartTableData(
        "admin/assessments/" +
          res.response[this.state.infofields.id] +
          "/completed_assessment/",
        text => this.handleAssessmentResultsLoaded(text)
      );
    } else if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public handleAssessmentResultsLoaded(res) {
    if (res.code === 200) {
      // console.log("responseloaded:", JSON.stringify(res.response, null, 4));
      this.setState({ loaded: true });
      this.setState({ assessmentinfo: res.response });
    }

    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public onProfile(arg) {
    console.log("profile in Parent", arg);
    this.setState({ toProfile: true });
  }

  public onLogout(arg) {
    console.log("Logout in Parent", arg);
    this.setState({ tologin: true });
  }

  public openWidget(param, e) {
    console.log("widget: " + param);
    this.setState({ destination: currentBaseUrl() + param });
    console.log("Widget COmplete URL: " + currentBaseUrl() + " " + param);
    this.setState({ navigate: true });
  }

  // content methods
  public chooseCategory(evtKey, event) {
    this.setState({ sideNavCategory: evtKey });
  }

  // close side nav on click outside
  public onClickOutside() {
    this.setState({ sideNavOpen: false });
  }

  public toggleSideNav() {
    const navstate = this.state.sideNavOpen;
    this.setState({ sideNavOpen: !navstate });
  }

  public getCategoryViz() {
    console.log("Sidenav item clicked");
    if (this.state.sideNavCategory === "summary") {
      return this.getSummaryViz();
    } else if (this.state.sideNavCategory === "my-assessments") {
      return this.getAssessmentsViz();
    } else if (this.state.sideNavCategory === "perceptions") {
      return this.getPerceptionsPlot();
    } else {
      return <div>No data to show yet</div>;
    }
  }
  public getSummaryViz() {
    return (
      <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
        <div className="student-data-summary">
          <div className="student-center-header-row">
            <h1 className="dashboard-name">
              PROGRESS AND ATTAINMENT DASHBOARD
            </h1>
            <button
              className="green-button upgrade"
              onClick={this.openWidget.bind(this, "packages")}
            >
              UPGRADE <br />
              NOW
            </button>
          </div>
          <div className="student-center-row">
            <div className="student-summary summary-left">
              <h2 className="tile-name">SUMMARY</h2>
              <div className="summary-details">
                <div className="student-details">
                  <h4 className="detail-name">Name</h4>
                  <p className="detail-value">{this.state.currentUser}</p>
                  <h4 className="detail-name">Age</h4>
                  <p className="detail-value">
                    {currentUserAge()} Years Old
                  </p>{" "}
                  {/* replace with actual data */}
                  <h4 className="detail-name">Institution</h4>
                  <p className="detail-value">{currentUserSchool()}</p>{" "}
                  {/* replace with actual data */}
                </div>
                <div className="student-assessments">
                  <h4 className="detail-name">Complete Assessments</h4>

                  <div id="value-border1">
                    <p style={{ margin: "0" }} className="complete-assessments">
                      {this.state.breakdown.completed}
                    </p>
                  </div>
                  <h4 className="detail-name">Incomplete Assessments</h4>

                  <div id="value-border2">
                    <p
                      style={{ margin: "0" }}
                      className="incomplete-assessments"
                    >
                      {this.state.breakdown.incomplete}
                    </p>
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* end summary left */}
            <div className="student-trait summary-right">
              <h2 className="trait-tile-name">YOUR PERFORMANCE LEARNING SCORE AND PROFILE</h2>
              <TraitTile results={this.state.assessmentinfo.results} vimeoModel="students" />
            </div>{" "}
            {/* end summary right */}
          </div>{" "}
          {/* end row1 */}
          <div className="student-center-row">
            <div className="student-perceptions">
              {/* <h2 className="trait-tile-name">PERCEPTIONS</h2> */}
              <PerceptionsTile
                results={this.state.assessmentinfo.results}
                services={this.props.services}
              />
            </div>
            <div className="student-responses">
              <ResponsesTile responseData={this.state.assessmentinfo.results} />
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }

  public getAssessmentsViz() {
    if (this.state.breakdown.completed > 1) {
      return (
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="student-assessments-data">
            <div className="student-center-header">
              <h1 className="dashboard-name">ASSESSMENTS RESULTS</h1>
              <p className="data-guide">
                {" "}
                Choose an <span>assessment</span> to see how you{" "}
                <span>performed</span>
              </p>
            </div>
            <div className="student-center-row">
              <select
                onChange={this.handleAssessmentChosen}
                style={{ width: "500px" }}
                name="student-assessments"
                id="student-assessments"
                className="custom-select assessments-select"
              >
                {this.state.breakdown.assessments.map((d) => (
                  <option
                    key={d.id}
                    value={d.id}
                    selected={d.id === this.state.currentassessmentid}
                  >
                    {d.Title}
                  </option>
                ))}
              </select>

              <button className="save-report blue-button">SAVE REPORT</button>
            </div>
            <h2 className="selected-assessment">
              Assessment{" "}
              <span> {this.state.assessmentinfo.assessment_info.Title}</span>
            </h2>
            <div className="student-center-row">
              <div className="student-perceptions">
                <PerceptionsTile
                  results={this.state.assessmentinfo.results}
                  services={this.props.services}
                />
              </div>
              <div className="student-responses">
                <ResponsesTile
                  responseData={this.state.assessmentinfo.results}
                />
              </div>
            </div>
          </div>
        </CSSTransition>
      );
    } else {
      return (
        <div className="dc-no-content">
          <h1 className="dashboard-name">
            <span>Hi {currentUser()}</span>, this section is available once you
            complete more assessments
          </h1>
        </div>
      );
    }
  }

  public getPerceptionsPlot() {
    if (this.state.breakdown.completed > 0) {
      return (
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="student-data-summary">
            <div className="student-center-header">
              <h1 className="dashboard-name">
                YOUR <span>PERCEPTIONS</span>
              </h1>
            </div>
            <div className="student-perceptions-plot">
              <div className="perceptions-grid">
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    Perception towards <span>self</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#08e666"
                    pointColor="#95f0c5"
                  />{" "}
                  {/* perception specific added as prop */}
                </div>
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    perception towards <span>school</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#c60ecc"
                    pointColor="#fa76f8"
                  />{" "}
                  {/* perception specific added as prop */}
                </div>
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    Perception Towards <span>Readiness to learn</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#4510b0"
                    pointColor="#bba1fc"
                  />{" "}
                  {/* perception specific added as prop */}
                </div>
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    Perception towards <span>Teachers</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#e3b910"
                    pointColor="#ffe799"
                  />{" "}
                  {/* perception specific added as prop */}
                </div>
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    Perception towards <span>Learning</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#08e666"
                    pointColor="#95f0c5"
                  />{" "}
                  {/* perception specific added as prop */}
                </div>
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    Effort & Determination towards <span>work</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#08e666"
                    pointColor="#95f0c5"
                  />{" "}
                  {/* perception specific added as prop */}
                </div>
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    Perception towards <span>Showing up to learn</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#cf1b69"
                    pointColor="#ff96be"
                  />
                  {/* perception specific added as prop */}
                </div>
                <div className="perception-graph-holder">
                  <h2 className="perception-plot-title">
                    Response to <span>subject demands</span>
                  </h2>
                  <PerceptionScatterGraph
                    lineColor="#b119cc"
                    pointColor="#e79bf5"
                  />
                  {/* perception specific added as prop */}
                </div>
              </div>
            </div>
            {/* end row1 */}
          </div>
        </CSSTransition>
      );
    } else {
      return (
        <div className="dc-no-content">
          <h1 className="dashboard-name">
            <span>Hi {currentUser()}</span>, this section is available once you
            complete more assessments
          </h1>
        </div>
      );
    }
  }

  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    if (!isUserLoggedIn()) {
      return <Redirect to="/login" />;
    }

    if (this.state.toProfile) {
      return <Redirect to={this.state.baseurl + "profile"} />;
    }

    if (this.state.navigate) {
      return (
        <Redirect
          from={currentBaseUrl + "/datacenter"}
          to={this.state.destination}
        />
      );
    }

    return (
      <div className="data-center">
        <NavBar logoutParent={this.onLogout} profileParent={this.onProfile} />
        <ClickOutside onClickOutside={this.onClickOutside}>
          <Sidenav
            onSelect={this.chooseCategory}
            className="datacenter-nav"
            expanded={this.state.sideNavOpen}
            onToggle={this.toggleSideNav}
          >
            <Sidenav.Toggle />
            <Sidenav.Nav defaultSelected="summary">
              <NavItem eventKey="summary">
                <NavIcon>
                  {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon1}/> */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "summary"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    S
                  </span>
                </NavIcon>
                <NavText>Summary</NavText>
              </NavItem>
              <NavItem eventKey="my-assessments">
                <NavIcon>
                  {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon2}/> */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "my-assessments"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    A
                  </span>
                </NavIcon>
                <NavText>My Assessments</NavText>
              </NavItem>
              <NavItem eventKey="perceptions">
                <NavIcon>
                  {/* icon goes here */}
                  {/* <img style={{width:"30px", paddingTop: "6px"}} src={icon3}/> */}
                  <span
                    className="navicon"
                    style={
                      this.state.sideNavCategory === "perceptions"
                        ? { color: "#ff0033" }
                        : { color: "#fff" }
                    }
                  >
                    P
                  </span>
                </NavIcon>
                <NavText>My Perceptions</NavText>
              </NavItem>
            </Sidenav.Nav>
          </Sidenav>
        </ClickOutside>
        <div className="data-container">
          {this.getCategoryViz()}
        </div>
      </div>
    );
  }
}
export default StudentDataCenter;



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Student/StudentDataCenter.Component.tsx